<template>
    <div class="page">
        <v-container :class="{'px-0': phoneOnly}">
            <div>
                <v-card :flat="phoneOnly" class="px-2 px-lg-3 soft-shadow">
                    <v-card-title class="d-flex justify-space-between">
                        <div>
                            Transactions History
                        </div>
                        <div class="px-3">
                            
                        </div>
                    </v-card-title>
                    <v-card-subtitle>List of recharges, class payments and other transactions of your account</v-card-subtitle>
                    <v-card-text v-if="!loading" :class="{'px-0': phoneOnly}">
                        <!-- Desktop Table View -->
                        <v-simple-table v-if="items && items.length && !phoneOnly" class="e-data-table">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Serial
                                        </th>
                                        <th class="text-left">
                                            Transaction Details
                                        </th>
                                        <th class="text-left">
                                            Amount
                                        </th>
                                        <th class="text-right">
                                            Created At
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in items" :key="i">
                                        <td>#{{item.serial}}</td>
                                        <td>
                                            <div v-if="item.type === 'recharge'">
                                                <v-icon color="success" size="19" class="me-2">mdi-wallet-plus</v-icon>
                                                Wallet Recharge Transaction
                                                <v-chip v-if="item.has_cashback" x-small color="success" class="ms-2" outlined>
                                                    <v-icon left x-small>mdi-gift</v-icon>
                                                    +${{ item.cashback_amount.toFixed(2) }} Cashback
                                                </v-chip>
                                                <v-chip v-if="item.has_fee" x-small color="orange" class="ms-2" outlined>
                                                    <v-icon left x-small>mdi-percent</v-icon>
                                                    {{ item.fee_percentage }}% Fee
                                                </v-chip>
                                            </div>
                                            <div class="details-text" v-else-if="item.type === 'class_payment'">
                                                <v-icon color="text" size="20" class="me-2">mdi-cash-check</v-icon>
                                                <template v-if="item.class && item.class.enrollment && item.class.enrollment.course">
                                                    Class: <v-btn class="px-1" color="strong-text" style="text-decoration: underline; text-transform: none;" :to="{name: 'course', params: {id: item.class.enrollment.course.id}}" text small>
                                                        {{item.class.enrollment.course.name}}
                                                    </v-btn>
                                                </template>
                                                <span v-else>Class Payment</span>
                                            </div>
                                            <div class="details-text" v-else-if="item.type === 'family_balance_transfer'">
                                                <v-icon color="blue darken-3" size="20" class="me-2">mdi-account-supervisor-circle</v-icon>
                                                <span>Family: </span> <span class="strong-text--text">{{item.comment}}</span>
                                            </div>
                                            <div class="details-text d-flex" v-else-if="item.type === 'admin_credits_update'" style="white-space: normal;">
                                                <v-icon color="primary" size="20" class="me-2">mdi-lifebuoy</v-icon>
                                                <div><span>Support: </span> <span class="strong-text--text">{{item.comment}}</span></div>
                                            </div>
                                            <div class="details-text" v-else-if="item.type === 'borrow_balance'">
                                                <v-icon color="deep-purple darken-1" size="20" class="me-2">mdi-cash-plus</v-icon>
                                                <span class="strong-text--text">{{item.comment}}</span>
                                            </div>
                                            <div class="details-text" v-else-if="item.type === 'borrow_balance_deduct'">
                                                <v-icon color="deep-purple darken-1" size="20" class="me-2">mdi-cash-minus</v-icon>
                                                <span class="strong-text--text">{{item.comment}}</span>
                                            </div>
                                            <div v-else-if="item.type === 'referral_reward'">
                                                <v-icon color="indigo darken-3" size="19" class="me-2">mdi-wallet-giftcard</v-icon>
                                                Referral Reward
                                            </div>
                                            <div v-else-if="item.type === 'wise_reward'">
                                                <v-icon color="indigo darken-3" size="19" class="me-2">mdi-creation-outline</v-icon>
                                                {{item.comment}}
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="item.type === 'recharge'">
                                                <span class="font-weight-bold green--text text--darken-1">+ {{moneyFormat(item.amount)}}</span>
                                                <div v-if="item.has_cashback" class="caption grey--text mt-1">
                                                    (Paid: ${{ item.paid_amount.toFixed(2) }} + Cashback: ${{ item.cashback_amount.toFixed(2) }})
                                                </div>
                                                <div v-if="item.has_fee" class="caption orange--text text--darken-2 mt-1">
                                                    (Charged: ${{ (item.paid_amount + item.fee_amount).toFixed(2) }}, includes ${{ item.fee_amount.toFixed(2) }} fee)
                                                </div>
                                            </div>
                                            <span v-else-if="item.type === 'class_payment'" class="font-weight-bold red--text">- {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.type === 'borrow_balance'" class="font-weight-bold deep-purple--text text--darken-1">+ {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.type === 'borrow_balance_deduct'" class="font-weight-bold error--text">- {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.type === 'referral_reward' || item.type === 'wise_reward'" class="font-weight-bold indigo--text text--darken-3">+ {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.isWalletLog">
                                                <span v-if="item.value >= 0" class="font-weight-bold blue--text text--darken-3">+ {{moneyFormat(item.value)}}</span>
                                                <span v-if="item.value < 0" class="font-weight-bold red--text">- {{moneyFormat(-1 * item.value)}}</span>
                                            </span>
                                            <span v-if="item.credits_after" class="details-text ms-2 muted--text">(Balance: {{moneyFormat(item.credits_after)}})</span>
                                        </td>
                                        <td class="text-right">{{dateTimeFormat(item.timestamp, true)}} <span class="muted--text">({{item.created_at_readable}})</span></td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <!-- Mobile Card View -->
                        <div v-else-if="items && items.length && phoneOnly" class="transactions-mobile-list">
                            <v-card 
                                v-for="(item, i) in items" 
                                :key="i" 
                                class="transaction-card mb-3 soft-shadow"
                                outlined
                            >
                                <v-card-text class="pa-3">
                                    <!-- Header Row: Serial and Amount -->
                                    <div class="d-flex justify-space-between align-center mb-2">
                                        <div class="caption grey--text font-weight-medium">
                                            #{{item.serial}}
                                        </div>
                                        <div class="transaction-amount">
                                            <div v-if="item.type === 'recharge'">
                                                <div class="font-weight-bold green--text text--darken-1 text-h6">
                                                    + {{moneyFormat(item.amount)}}
                                                </div>
                                                <div v-if="item.has_cashback" class="caption grey--text text-right mt-1">
                                                    Paid: ${{ item.paid_amount.toFixed(2) }}<br>
                                                    Cashback: ${{ item.cashback_amount.toFixed(2) }}
                                                </div>
                                                <div v-if="item.has_fee" class="caption orange--text text--darken-2 text-right mt-1">
                                                    Charged: ${{ (item.paid_amount + item.fee_amount).toFixed(2) }}<br>
                                                    Fee: ${{ item.fee_amount.toFixed(2) }} ({{ item.fee_percentage }}%)
                                                </div>
                                            </div>
                                            <span v-else-if="item.type === 'class_payment'" class="font-weight-bold red--text text-h6">- {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.type === 'borrow_balance'" class="font-weight-bold deep-purple--text text--darken-1 text-h6">+ {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.type === 'borrow_balance_deduct'" class="font-weight-bold error--text text-h6">- {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.type === 'referral_reward' || item.type === 'wise_reward'" class="font-weight-bold indigo--text text--darken-3 text-h6">+ {{moneyFormat(item.value)}}</span>
                                            <span v-else-if="item.isWalletLog">
                                                <span v-if="item.value >= 0" class="font-weight-bold blue--text text--darken-3 text-h6">+ {{moneyFormat(item.value)}}</span>
                                                <span v-if="item.value < 0" class="font-weight-bold red--text text-h6">- {{moneyFormat(-1 * item.value)}}</span>
                                            </span>
                                        </div>
                                    </div>

                                    <!-- Transaction Details -->
                                    <div class="transaction-details mb-2">
                                        <div v-if="item.type === 'recharge'" class="d-flex align-center">
                                            <v-icon color="success" size="22" class="me-2">mdi-wallet-plus</v-icon>
                                            <div>
                                                <div class="font-weight-medium">Wallet Recharge</div>
                                                <v-chip v-if="item.has_cashback" x-small color="success" class="mt-1" outlined>
                                                    <v-icon left x-small>mdi-gift</v-icon>
                                                    +${{ item.cashback_amount.toFixed(2) }} Cashback
                                                </v-chip>
                                                <v-chip v-if="item.has_fee" x-small color="orange" class="mt-1 ms-1" outlined>
                                                    <v-icon left x-small>mdi-percent</v-icon>
                                                    {{ item.fee_percentage }}% Fee
                                                </v-chip>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'class_payment'" class="d-flex align-start">
                                            <v-icon color="text" size="22" class="me-2 mt-1">mdi-cash-check</v-icon>
                                            <div>
                                                <div class="caption grey--text mb-1">Class Payment</div>
                                                <template v-if="item.class && item.class.enrollment && item.class.enrollment.course">
                                                    <v-btn 
                                                        class="px-1 text-left" 
                                                        color="strong-text" 
                                                        style="text-decoration: underline; text-transform: none; height: auto; min-height: 28px;" 
                                                        :to="{name: 'course', params: {id: item.class.enrollment.course.id}}" 
                                                        text 
                                                        x-small
                                                    >
                                                        {{item.class.enrollment.course.name}}
                                                    </v-btn>
                                                </template>
                                                <span v-else class="font-weight-medium">Class Payment</span>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'family_balance_transfer'" class="d-flex align-start">
                                            <v-icon color="blue darken-3" size="22" class="me-2">mdi-account-supervisor-circle</v-icon>
                                            <div>
                                                <div class="caption grey--text mb-1">Family Transfer</div>
                                                <div class="font-weight-medium">{{item.comment}}</div>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'admin_credits_update'" class="d-flex align-start">
                                            <v-icon color="primary" size="22" class="me-2">mdi-lifebuoy</v-icon>
                                            <div>
                                                <div class="caption grey--text mb-1">Support Adjustment</div>
                                                <div class="font-weight-medium">{{item.comment}}</div>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'borrow_balance'" class="d-flex align-start">
                                            <v-icon color="deep-purple darken-1" size="22" class="me-2">mdi-cash-plus</v-icon>
                                            <div>
                                                <div class="caption grey--text mb-1">Balance Borrow</div>
                                                <div class="font-weight-medium">{{item.comment}}</div>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'borrow_balance_deduct'" class="d-flex align-start">
                                            <v-icon color="deep-purple darken-1" size="22" class="me-2">mdi-cash-minus</v-icon>
                                            <div>
                                                <div class="caption grey--text mb-1">Balance Deduction</div>
                                                <div class="font-weight-medium">{{item.comment}}</div>
                                            </div>
                                        </div>
                                        <div v-else-if="item.type === 'referral_reward'" class="d-flex align-center">
                                            <v-icon color="indigo darken-3" size="22" class="me-2">mdi-wallet-giftcard</v-icon>
                                            <div class="font-weight-medium">Referral Reward</div>
                                        </div>
                                        <div v-else-if="item.type === 'wise_reward'" class="d-flex align-start">
                                            <v-icon color="indigo darken-3" size="22" class="me-2">mdi-creation-outline</v-icon>
                                            <div class="font-weight-medium">{{item.comment}}</div>
                                        </div>
                                    </div>

                                    <!-- Balance After (if exists) -->
                                    <div v-if="item.credits_after" class="caption grey--text mb-2">
                                        <v-icon size="14" class="me-1">mdi-wallet</v-icon>
                                        Balance After: <span class="font-weight-medium">{{moneyFormat(item.credits_after)}}</span>
                                    </div>

                                    <!-- Divider -->
                                    <v-divider class="my-2"></v-divider>

                                    <!-- Footer: Date and Time -->
                                    <div class="d-flex justify-space-between align-center">
                                        <div class="caption grey--text">
                                            <v-icon size="14" class="me-1">mdi-calendar</v-icon>
                                            {{dateTimeFormat(item.timestamp, true)}}
                                        </div>
                                        <div class="caption grey--text">
                                            {{item.created_at_readable}}
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </div>

                        <div v-else-if="!loading">
                            <v-alert type="info" color="blue-grey" text>
                                No transactions were found
                            </v-alert>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-container>
        
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'


export default {
    name: "transactions-history",
    components: {
        
    },
    data(){
        return {
            searchQuery: '',
            loading: false,
        }
    },
    computed: {
        paymentHistoryData(){
            return this.$store.state.historyModule.paymentHistoryData;
        },
        items(){
            if (!this.paymentHistoryData){
                return [];
            }
            
            let recharges = this.paymentHistoryData.recharges || [];
            recharges = recharges.map(recharge=>{recharge.type = 'recharge'; return recharge;});
            
            let class_payments = this.paymentHistoryData.class_payments || [];
            class_payments = class_payments.map(payment=>{payment.type = 'class_payment'; return payment;});

            let wallet_logs = this.paymentHistoryData.wallet_logs || []; // it has it's type property, as logs not the same type
            wallet_logs = wallet_logs.map(log=>{log.isWalletLog = true; return log;});

            let items = [...wallet_logs, ...recharges, ...class_payments];
            return items.sort((a, b)=>{
                if (a.timestamp - b.timestamp !== 0){
                    return a.timestamp - b.timestamp;
                }else{
                    return a.serial - b.serial;
                }
            }).reverse(); // reverse means 'Desc' not 'Asc'
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('loadTransactionsData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        ...GlobalMethods
    },
    mounted(){
        if (this.appData && !this.appData.enable_app_w){
            this.$router.push('/not-found');
        }else {
            if (!this.paymentHistoryData.recharges || !this.paymentHistoryData.class_payments){
                this.loadData();
            }
        }
    }
};
</script>

<style scoped lang="scss">
.transactions-mobile-list {
    .transaction-card {
        border-radius: 12px;
        transition: all 0.2s ease;
        
        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        }
    }
    
    .transaction-amount {
        text-align: right;
        line-height: 1.2;
    }
    
    .transaction-details {
        font-size: 0.95rem;
        line-height: 1.5;
    }
}
</style>
